import React from 'react';

export default function PrivacyPolicy() {
    return (
        <>
        <h1 className="top_header">Privacy Policy</h1>

        <div className="body_of_text">
            <h3>Data Collected:</h3>
            <p>This website collects data on various performance metrics through Google Analytics. 
                This data includes page views, scrolls, and clicks, among other information. For the contact form,
                an email is requested. Users can send along other information, such as their name and phone number.
            </p>

            <h3>Processing Purposes:</h3>
            <p>The Google Analytics data is used to monitor and improve website performance. Data submitted through 
                the contact form is used for communication with potential clients.
            </p>

            <h3>Data Storage:</h3>
            <p>Client contact information is kept on email and phone. No other storage or protection of data is used (small business).
            </p>

            <h3>Third Parties:</h3>
            <p>Some data will be shared with Google for advertising purposes. EmailJS may receive data after
                filling out the contact form. No other third party will receive user data.
            </p>

            <h3>User Rights:</h3>
            <p>Contact information such as email, name, and phone number may be collected. Do not fill out a contact form if you wish to remain anonymous. 
                If you wish to opt out of Google Analytics tracking, consider using an adblocker on this site.
            </p>
        </div>
        </>
    )
} 